(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessible-carousel"] && !Shopify.designMode) return;
  try {
    
    class AccessibleSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
                const scope = this;
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 1,
                    autoplay: this.dataset.autoplay === 'true' ? true : false,
										speed: Number(this.dataset.speed),
                    navigation: {
                      nextEl: '.swiper-next',
                      prevEl: '.swiper-prev',
                    },
                    on: {
                      init: function () {
                          const slide = scope.querySelector('.swiper-slide-active .hero');
                          if(slide){
                            let navColor = slide.dataset.arrow
                            scope.querySelector('.swiper-next').style.color = navColor;
                            scope.querySelector('.swiper-prev').style.color = navColor;
                          }
                      },
                    },
								});

                this.swiper.on('slideChangeTransitionStart', function () {
                    const slide = scope.querySelector('.swiper-slide-active .hero');
                    let navColor = slide.dataset.arrow
                    scope.querySelector('.swiper-next').style.color = navColor;
                    scope.querySelector('.swiper-prev').style.color = navColor;
                });

						})
				}
    }
    customElements.define('accessible-carousel', AccessibleSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
    class SearchBlogs extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector("#blog-search");
            this.results = [];
            this.articlesContainter = document.querySelector("[data-articles]");
            this.resultsContainter = document.querySelector("[data-results]");

        }
				connectedCallback() {
            this.input.addEventListener('input', this.debounce((event) => {
              this.onChange(event);
            }, 500).bind(this));
				}
        onChange() {
            const searchTerm = this.input.value.trim();
            if (searchTerm.length) {
            fetch(`/search?q=${encodeURIComponent(searchTerm)}&view=blogs&type=article`, {
                method: 'GET',
                })
                .then((response) => response.json())
                .then((parsedState) => {
                    this.results = parsedState.results
                    this.setResults();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }else{
              this.articlesContainter.classList.remove("hidden");
              this.resultsContainter.classList.add("hidden");
            }

        }
        setResults(){
          if(this.results.length > 0){
            let html = "";
            for (let i = 0; i < this.results.length; i++) {
               const item = this.results[i];
               html += ` <div class="blog-articles__article article shadow-xl"  ><div class="card-wrapper underline-links-hover">
                  <div class="card article-card relative card-- article-card__image--medium card--media"
                    style="--ratio-percent: 66.650390625%;">
                    <div class="card__inner flex relative items-stretch grid grid-rows-1 {% if settings.card_style == 'standard' %} color-{{ settings.card_color_scheme }}{% endif %}{% if article.image and show_image or settings.card_style == 'standard' %} ratio{% endif %}" style="--ratio-percent: {{ 1 | divided_by: ratio | times: 100 }}%;">
                        <div class="article-card__image-wrapper card__media w-full relative mb-4">
                          <div class="article-card__image overflow-hidden media media--hover-effect" {% if section.settings.media_height == 'adapt' %} style="padding-bottom: {{ 1 | divided_by: article.image.aspect_ratio | times: 100 }}%;"{% endif %}>
                            <img
                              src="${item.thumbnail}"
                              class="motion-reduce relative h-full w-full object-cover"
                            >
                          </div>
                        </div>
                    </div>
                    <div class="card__content md:px-8 px-8 py-4 pb-16  ">
                      <div class="card__information md:text-left">
                        <h3 class="card__heading mb-6  sm:text-lg ">
                          <a href="${item.url}" class="full-unstyled-link">
                            ${item.title}
                          </a>
                        </h3>
                        <div class="article-card__info caption-with-letter-spacing h5 flex flex-wrap">
                          <span class=" text-grayBtn caption-with-letter-spacing text-base font-heading">${item.date}</span>
                        </div>
                        <p class="article-card__excerpt rte-width mt-4">
                          ${item.text_content}
                        </p>
                      </div>
                    </div>
                  </div>
                </div></div>`;
            }

            this.resultsContainter.innerHTML =  html;
          }
          this.articlesContainter.classList.add("hidden");
          this.resultsContainter.classList.remove("hidden");
        }
        debounce(fn, wait) {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        }
    }
    customElements.define('search-blogs', SearchBlogs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load",()=>{let t=[...document.querySelectorAll("[data-copy]")];t.forEach(t=>{t.addEventListener("click",()=>{navigator.clipboard.writeText(t.textContent).then(()=>{t.textContent="Copied!",setTimeout(()=>{t.textContent=t.dataset.copy},1e3)})})})});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
    class HeroSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
                const scope = this;
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 1,
                    autoplay: this.dataset.autoplay === 'true' ? true : false,
										speed: Number(this.dataset.speed),
                    navigation: {
                      nextEl: '.swiper-next',
                      prevEl: '.swiper-prev',
                    },
                    on: {
                      init: function () {
                          const slide = scope.querySelector('.swiper-slide-active .hero');
                          if(slide){
                            let navColor = slide.dataset.arrow
                            scope.querySelector('.swiper-next').style.color = navColor;
                            scope.querySelector('.swiper-prev').style.color = navColor;
                          }
                      },
                    },
								});

                this.swiper.on('slideChangeTransitionStart', function () {
                    const slide = scope.querySelector('.swiper-slide-active .hero');
                    let navColor = slide.dataset.arrow
                    scope.querySelector('.swiper-next').style.color = navColor;
                    scope.querySelector('.swiper-prev').style.color = navColor;
                });

						})
				}
    }
    customElements.define('hero-carousel', HeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-row"] && !Shopify.designMode) return;
  try {
    
class IconSlider extends HTMLElement{constructor(){super()}
connectedCallback(){window.addEventListener('load',()=>{this.swiper=new Swiper(this.querySelector('[data-swiper]'),{allowTouchMove:!0,direction:'horizontal',loop:!1,spaceBetween:0,slidesPerView:2,speed:Number(this.dataset.speed),navigation:{nextEl:'[data-swiper-button-next]',prevEl:'[data-swiper-button-prev]'},breakpoints:{768:{slidesPerGroup:3,slidesPerView:3,},992:{slidesPerGroup:4,slidesPerView:4,},1280:{slidesPerGroup:4,slidesPerView:4,}}})})}}
customElements.define('icon-carousel',IconSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-carousel"] && !Shopify.designMode) return;
  try {
    
    class PartnerSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '[data-swiper-button-next]',
                    prevEl: '[data-swiper-button-prev]'
                };
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 2,
                    autoplay: this.dataset.autoplay === 'true' ? true : false,
										speed: Number(this.dataset.speed),
										navigation: this.dataset.arrows === 'true' ? nav : false ,
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('partner-carousel', PartnerSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-logos"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ram-images-with-title"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ram-images"] && !Shopify.designMode) return;
  try {
    
    class IconSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {
						window.addEventListener('load', () => {
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: false,
										spaceBetween:0,
										slidesPerView: 2,

										speed: Number(this.dataset.speed),
										navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]'
                    },
										breakpoints: {
												768: {
													slidesPerGroup: 3,
													slidesPerView: 3,
												},
												992: {
													slidesPerGroup: 4,
													slidesPerView: 4,
												},
						            1280: {
						              	slidesPerView: Number(this.dataset.slider_slides)
						            }
						         }
								});
						})
				}
    }
    customElements.define('icon-carousel', IconSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
    class Slider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            window.addEventListener('load', () => {
                this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
                    // Optional parameters
                    autoplay: {
                        delay: Number(this.dataset.speed),
                        disableOnInteraction: false,
                    },
                    direction: 'horizontal',
                    loop: false,
                    navigation: {
                        nextEl: '[data-swiper-button-next]',
                        prevEl: '[data-swiper-button-prev]',
                    },
                    slidesPerView: "auto",
                    speed: Number(this.dataset.speed)
                });
            })
        }
    }
    customElements.define('testimonial-slider', Slider);

  } catch(e) { console.error(e); }
})();
})();
